// src/ui/ClipLibraryPanel.js
// Panel that lists all saved clip definitions and allows drag-to-sequencer placement.

import { clipLibrary } from '../clips/ClipLibrary.js';

export class ClipLibraryPanel {
  constructor(rootEl, trackManager) {
    this.root = rootEl;
    this.tm = trackManager;
    clipLibrary.onChange(() => this.render());

    // Drag start: set the clip-id data transfer so the sequencer can accept it
    this.root.addEventListener('dragstart', (e) => {
      const entry = e.target.closest('.clip-library-entry');
      if (!entry) return;
      e.dataTransfer.setData('text/clip-id', entry.dataset.clipId);
      e.dataTransfer.effectAllowed = 'copy';
    });

    // Double-click to rename
    this.root.addEventListener('dblclick', (e) => {
      const nameEl = e.target.closest('.clip-library-name');
      if (!nameEl) return;
      const entry = nameEl.closest('.clip-library-entry');
      if (!entry) return;
      const clipId = entry.dataset.clipId;
      if (!clipId) return;

      const input = document.createElement('input');
      input.type = 'text';
      input.value = nameEl.textContent;
      input.className = 'clip-library-rename-input';
      nameEl.replaceWith(input);
      input.focus();
      input.select();

      const commit = () => {
        const val = input.value.trim();
        if (val) {
          clipLibrary.renameClip(clipId, val);
        } else {
          // Restore original name if empty
          clipLibrary.renameClip(clipId, nameEl.textContent);
        }
        // render() fires via clipLibrary.onChange
      };
      input.addEventListener('blur', commit);
      input.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter') { input.blur(); }
        if (ev.key === 'Escape') { input.value = nameEl.textContent; input.blur(); }
      });
    });

    this.render();
  }

  render() {
    if (clipLibrary.definitions.length === 0) {
      this.root.innerHTML = '<p class="clip-library-empty">Record a clip to get started</p>';
      return;
    }
    let html = '<div class="clip-library-list">';
    for (const def of clipLibrary.definitions) {
      const count = def.notes.length;
      html += `
        <div class="clip-library-entry" data-clip-id="${def.id}" draggable="true">
          <span class="clip-library-name">${def.name.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</span>
          <span class="clip-library-meta">${count} note${count !== 1 ? 's' : ''}</span>
          <button class="clip-library-place" title="Place on track">+</button>
        </div>
      `;
    }
    html += '</div>';
    this.root.innerHTML = html;

    // Wire place buttons
    this.root.querySelectorAll('.clip-library-place').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const entry = e.target.closest('.clip-library-entry');
        if (!entry) return;
        const clipId = entry.dataset.clipId;
        // Place clip at time 0 on the first track
        if (this.tm.tracks.length > 0) {
          const track = this.tm.tracks[0];
          const def = clipLibrary.getClip(clipId);
          if (def) {
            track.addClipInstance(clipId, 0, 1);
          }
        }
      });
    });
  }
}
